import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../../store/store";
import { SoundsOrder } from "../../../../../reducers/sounds.reducer";

import { levelTextById } from "../../../../Utils/get-sound-level";

import "./SoundsTable.component.scss";

export interface SoundsTableProps {
    editingConfiguration: any;
    soundDecibels: any;
    soundPercentage: any;
    rows: any;
    total: number;
    start: number;
    end: number;
    currentPage: number;
    pages: number;
    navigationAction: any;
    reorderAction: any;
    currentOrder: SoundsOrder;
    changeLevel: any;
    changeSubLevel: any;
}

class SoundsTable extends Component<SoundsTableProps, {}> {
    reorderColumn = key => {
        let direction = "asc";
        if (key === this.props.currentOrder.key) {
            if (direction === this.props.currentOrder.direction) {
                direction = "desc";
            }
        }

        this.props.reorderAction(key, direction);
    };

    render() {
        const levels = [
            {
                value: 1,
                label: levelTextById(1)
            },
            {
                value: 2,
                label: levelTextById(2)
            },
            {
                value: 3,
                label: levelTextById(3)
            },
            {
                value: 4,
                label: levelTextById(4)
            },
            {
                value: 5,
                label: levelTextById(5)
            }
        ];

        const subLevels = [
            {
                value: 1,
                label: levelTextById(2)
            },
            {
                value: 2,
                label: levelTextById(3)
            },
            {
                value: 3,
                label: levelTextById(4)
            }
        ];

        return (
            <table id="table-sounds">
                <thead>
                    <tr>
                        <th onClick={() => this.reorderColumn("description")}>
                            <div>
                                Games
                                {this.props.currentOrder.key ==
                                    "description" && (
                                    <span className="material-icons">
                                        {this.props.currentOrder.direction ==
                                        "asc"
                                            ? "keyboard_arrow_down"
                                            : "keyboard_arrow_up"}
                                    </span>
                                )}
                            </div>
                        </th>
                        <th
                            onClick={() =>
                                this.reorderColumn("group_description")
                            }
                        >
                            <div>
                                Sound Group
                                {this.props.currentOrder.key ==
                                    "group_description" && (
                                    <span className="material-icons">
                                        {this.props.currentOrder.direction ==
                                        "asc"
                                            ? "keyboard_arrow_down"
                                            : "keyboard_arrow_up"}
                                    </span>
                                )}
                            </div>
                        </th>
                        <th onClick={() => this.reorderColumn("level")}>
                            <div>
                                Levels
                                {this.props.currentOrder.key == "level" && (
                                    <span className="material-icons">
                                        {this.props.currentOrder.direction ==
                                        "asc"
                                            ? "keyboard_arrow_down"
                                            : "keyboard_arrow_up"}
                                    </span>
                                )}
                            </div>
                        </th>
                        <th onClick={() => this.reorderColumn("sub_level")}>
                            <div>
                                Sub-Levels
                                {this.props.currentOrder.key == "sub_level" && (
                                    <span className="material-icons">
                                        {this.props.currentOrder.direction ==
                                        "asc"
                                            ? "keyboard_arrow_down"
                                            : "keyboard_arrow_up"}
                                    </span>
                                )}
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.rows.map(row => {
                        return (
                            <tr
                                key={`${row.id}-${row.level}-${row.sub_level}-${row.identifier}`}
                            >
                                <td>{row.description}</td>
                                <td>{row.group_description}</td>
                                <td>
                                    {
                                        <React.Fragment>
                                            {row.level !==
                                                row.originalLevel && (
                                                <span className="changed"></span>
                                            )}
                                            <Components.SelectMenu
                                                items={levels}
                                                noValueLabel={"Level"}
                                                value={
                                                    row.level ? row.level : 3
                                                }
                                                onChange={value =>
                                                    this.props.changeLevel(
                                                        row.identifier,
                                                        row.id,
                                                        value
                                                    )
                                                }
                                            />
                                        </React.Fragment>
                                    }
                                </td>
                                <td>
                                    {row.sub_level_enabled && (
                                        <React.Fragment>
                                            {row.sub_level !==
                                                row.originalSubLevel && (
                                                <span className="changed"></span>
                                            )}
                                            <Components.SelectMenu
                                                items={subLevels}
                                                noValueLabel={"Sub-Level"}
                                                value={
                                                    row.sub_level
                                                        ? row.sub_level
                                                        : 2
                                                }
                                                onChange={value =>
                                                    this.props.changeSubLevel(
                                                        row.identifier,
                                                        row.id,
                                                        value
                                                    )
                                                }
                                            />
                                        </React.Fragment>
                                    )}
                                    {!row.sub_level_enabled && "-"}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = state => ({
    editingConfiguration: configurationsStoreSelectors.editingConfiguration(
        state
    ),
    soundDecibels: configurationsStoreSelectors.soundDecibels(state),
    soundPercentage: configurationsStoreSelectors.soundPercentage(state)
});

export default connect(
    mapStateToProps,
    {}
)(SoundsTable);
